import { useQuery } from '@tanstack/react-query'
import { supabase } from '../lib/supabase'
import type { SaleLineItem } from '../lib/database.types'

const LINE_ITEMS_KEY = ['sale_line_items']

export function useSaleLineItems() {
  return useQuery({
    queryKey: LINE_ITEMS_KEY,
    queryFn: async (): Promise<SaleLineItem[]> => {
      const { data, error } = await supabase
        .from('sale_line_items')
        .select('*')
        .order('created_at', { ascending: false })
      if (error) throw error
      return data ?? []
    },
  })
}

export const SALE_LINE_ITEMS_KEY = LINE_ITEMS_KEY
